import { globalStore } from '~/stores';
import { AppContexts, isEnvHostedContext } from '~/utils/commonUtils.ts';
import { useEnvAppDataContext } from '~/pages/ExternalPages/EnvAppPages/contexts/EnvAppDataContext.tsx';

enum WorkspacePermissions {
  // will add workspace permissions later
  // once we dog food the workspace permissions
  // we will populate this
}

enum EnvAppPermissions {
  ORG_USERS_READ = 'sk_org_users_read',
  ORG_USERS_INVITE = 'sk_org_users_invite',
  ORG_USERS_DELETE = 'sk_org_users_delete',
  ORG_USERS_ROLE_CHANGE = 'sk_org_users_role_change',
  ORG_SSO_READ = 'sk_org_sso_read',
  ORG_SSO_MANAGE = 'sk_org_sso_manage',
  ORG_SETTINGS_READ = 'sk_org_settings_read',
  ORG_SETTINGS_MANAGE = 'sk_org_settings_manage',
  ORG_SCIM_READ = 'sk_org_scim_read',
  ORG_SCIM_MANAGE = 'sk_org_scim_manage'
}

export type AppPermissions = WorkspacePermissions | EnvAppPermissions;
export type PermissionGroup = AppPermissions[];
export type PermissionRequirements = PermissionGroup[];

const anyOf = (...permissions: AppPermissions[]): PermissionGroup =>
  permissions;
const allOf = (...groups: PermissionGroup[]): PermissionRequirements => groups;

const getCurrentUserPermissions = (): AppPermissions[] => {
  if (isEnvHostedContext()) {
    const envAppData = useEnvAppDataContext();
    const currentMembership =
      envAppData.user?.memberships.find(
        ({ organizationId }) => organizationId === envAppData.organizationId
      ) ?? undefined;
    return currentMembership?.permissions ?? [];
  }
  return [];
};

const isAuthorized = (permissionsListArr: PermissionRequirements) => {
  if (globalStore.appContext !== AppContexts.ENV_APP_PAGES) {
    // @todo update during workspace dogfooding to check for workspace permissions
    // If not in Env App context, allow all permissions
    // this will change during implementation of workspace dogfooding
    return true;
  }
  const currentUserPermissions: AppPermissions[] = getCurrentUserPermissions();
  return permissionsListArr.every((permissions) =>
    permissions.some((permission) =>
      currentUserPermissions.includes(permission)
    )
  );
};

const isAuthorizedToManageScim = () =>
  isAuthorized(allOf(anyOf(EnvAppPermissions.ORG_SCIM_MANAGE)));

const isAuthorizedToManageSso = () =>
  isAuthorized(allOf(anyOf(EnvAppPermissions.ORG_SSO_MANAGE)));

export {
  WorkspacePermissions,
  EnvAppPermissions,
  anyOf,
  allOf,
  isAuthorized,
  isAuthorizedToManageScim,
  isAuthorizedToManageSso
};
